import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IEnums } from "../../shared/interfaces/shared/IEnums";
import { AuthService } from "../../authentification/service";

interface IEnumsState {
  data: IEnums | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: IEnumsState = {
  data: null,
  isLoading: false,
  error: null,
};

export const fetchEnums = createAsyncThunk("enums/fetch", async () => {
  const response = await AuthService.enums();
  return response as IEnums;
});

const enumsSlice = createSlice({
  name: "enums",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnums.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchEnums.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchEnums.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to fetch enums";
      });
  },
});

export default enumsSlice;
